import { Injectable } from '@angular/core';
import { requestWithToken, requestWithoutToken } from 'src/config';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  async generateOtp(payload: any) {
    return requestWithoutToken(
      "POST",
      "/auth/generate-otp",
      payload
    ).then((res) => {
      return res?.data;
    })
  }

  async verifyOTP(payload: any) {
    return requestWithoutToken(
      "POST",
      "/auth/validate-otp",
      payload
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async verifyEmailOTP(payload: any) {
    return requestWithoutToken(
      "POST",
      "/auth/validate-email",
      payload
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }


  async createPassword(payload: any) {
    return requestWithToken(
      "PUT",
      "/user/password",
      payload
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async fetchUserDetails() {
    return requestWithToken(
      "GET",
      "/user/profile"
    ).then((res) => {
      return res?.data;
    })
  }


  async createPersonalDetails(payload: any) {
    return requestWithToken(
      "POST",
      "/user/register",
      payload
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async fetchQualification() {
    return requestWithToken(
      "GET",
      "/masters/education",
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async fetchMaritalStatus() {
    return requestWithToken(
      "GET",
      "/masters/maritalStatus",
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }


  async fetchEntity() {
    return requestWithToken(
      "GET",
      "/masters/bEntity",
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async fetchBusinessCategory() {
    return requestWithToken(
      "GET",
      "/masters/bType",
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async fetchBusinessTurnover() {
    return requestWithToken(
      "GET",
      "/masters/turnover",
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async fetchNoBusinessOption() {
    return requestWithToken(
      "GET",
      "/masters/noBusOption",
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async fetchState() {
    return requestWithToken(
      "GET",
      "/masters/state",
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async fetchCity() {
    return requestWithToken(
      "GET",
      "/masters/city",
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }


  async fetchCtaRequestCallNumber() {
    return requestWithToken(
      "GET",
      "/masters/meta/request-call/en",
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }

  async fetchStateByPincode(pincode: any) {
    return requestWithToken(
      "GET",
      `/user/pincode?pincode=${pincode}`,
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }


  async fetchDocumentsList(categoryId: any, busTypeId: any) {
    return requestWithToken(
      "GET",
      `/masters/documents?cat-id=${categoryId}&type-id=${busTypeId}`,
    ).then((res) => {
      return res;
    }).catch((error) => {
      return error;
    })
  }

  async uploadUserDocument(payload: any) {
    return requestWithToken(
      "POST",
      "/user/document",
      payload
    ).then((res) => {
      return res;
    }).catch((error) => {
      return error;
    })
  }

}


